export const inr = (n, dp = 0) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return "₹" + Number(n).toLocaleString("en-IN", { minimumFractionDigits: dp, maximumFractionDigits: dp });
};

export const num = (n, dp = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toLocaleString("en-IN", { minimumFractionDigits: dp, maximumFractionDigits: dp });
};

export const pct = (n, dp = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toFixed(dp) + "%";
};

export const compact = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const a = Math.abs(n);
  if (a >= 1e7) return (n / 1e7).toFixed(2) + "Cr";
  if (a >= 1e5) return (n / 1e5).toFixed(2) + "L";
  if (a >= 1e3) return (n / 1e3).toFixed(1) + "K";
  return String(n);
};

// ₹ in compact Indian units for dense status displays (₹22.55L, ₹1.50Cr, ₹8,785).
export const inrCompact = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  const a = Math.abs(v), sign = v < 0 ? "-" : "";
  if (a >= 1e7) return `${sign}₹${(a / 1e7).toFixed(2)}Cr`;
  if (a >= 1e5) return `${sign}₹${(a / 1e5).toFixed(2)}L`;
  return `${sign}₹${Math.round(a).toLocaleString("en-IN")}`;
};

export const pnlColor =(n) => (n > 0 ? "text-[#00C805]" : n < 0 ? "text-[#FF3B30]" : "text-slate-400");

// Timestamps from the API are UTC; show them in the application's display timezone.
export const DISPLAY_TZ = "Asia/Kolkata";
// A stored IST calendar date ("2026-09-15") as "15 Sep 2026" — no timezone conversion, it already is IST.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const istDate = (ymd) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(ymd || "");
  return m ? `${m[3]} ${MONTHS[Number(m[2]) - 1]} ${m[1]}` : "—";
};

// UTC instant -> "HH:MM:SS" in IST (fallback when a record has no stored *_time field).
export const istTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleTimeString("en-GB", { timeZone: DISPLAY_TZ, hour12: false });
};

// UTC instant -> "YYYY-MM-DD" in IST (fallback when a record has no stored *_date field).
export const istYmd = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d)) return null;
  return d.toLocaleDateString("en-CA", { timeZone: DISPLAY_TZ });
};

export const dateTime = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d)) return "—";
  return d.toLocaleString("en-IN", { timeZone: DISPLAY_TZ, day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: false }) + " IST";
};

// A signed rupee P&L, one convention everywhere money gains or loses: the sign before the symbol,
// a true minus (−₹6,525.24, +₹620.00, ₹0.00) — the same text the Options trade cards use.
export const inrPnl = (n, dp = 2) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const v = Number(n);
  const body = "₹" + Math.abs(v).toLocaleString("en-IN", { minimumFractionDigits: dp, maximumFractionDigits: dp });
  return v < 0 ? "−" + body : v > 0 ? "+" + body : body;
};
